/* global debounce */
if (!customElements.get('cart-gift-option')) {
  class CartGiftOption extends HTMLElement {
    constructor() {
      super();

      this.fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      };

      this.gift = this.querySelector('[name="attributes[is-gift]"][type="checkbox"]');
      this.message = this.querySelector('[name="attributes[gift-message]"]');
      this.init();
    }

    init() {
      this.gift.addEventListener('change', this.handleGiftChange.bind(this));

      this.debouncedHandleMessageChange = debounce(this.handleMessageChange.bind(this), 300);
      // Save as soon as possible, avoid link-click not providing time to save
      this.message.addEventListener('keyup', this.debouncedHandleMessageChange);
      this.message.addEventListener('change', this.debouncedHandleMessageChange);
    }

    handleGiftChange(evt) {
      const isGift = evt.target.checked ? 'yes' : 'no';
      if (isGift === 'no') {
        this.message.value = '';
      }
      this.fetchRequestOpts.body = JSON.stringify(
        { 
          attributes: {
            'is-gift': isGift,
            'gift-message': this.message.value 
          }
        }
      );
      fetch(theme.routes.cartUpdate, this.fetchRequestOpts);
    }

    handleMessageChange(evt) {
      this.fetchRequestOpts.body = JSON.stringify(
        { 
          attributes: {
            'gift-message': evt.target.value 
          }
        }
      );
      fetch(theme.routes.cartUpdate, this.fetchRequestOpts);
    }
  }

  customElements.define('cart-gift-option', CartGiftOption);
}
